/**
 * JavaScript controller for shortcode: [links variant="property-count"]
 */
function initLinksPropertyCountPagination(el, model, $) {
  const $pagination = $(el);
  const $widget = $pagination.closest('.sc-links');
  const $nav = $widget.find('.sc-links__nav').first();
  const $items = $widget.find('.sc-links__link-rounded');
  const $range = $pagination.find('.pagination__page-range');
  const $prev = $pagination.find('.pagination__link--prev');
  const $next = $pagination.find('.pagination__link--next');

  if (!$items.length) {
    $pagination.hide();
    return;
  }

  const total = $items.length;
  const minFromModel = Number.parseInt(model.min, 10);
  const minFromData = Number.parseInt($widget.attr('data-min'), 10);
  const pageSize = Math.max(1, minFromModel || minFromData || 10);
  let pageIndex = 0;

  function setPaginationLinkDisabled($link, disabled) {
    $link.toggleClass('disabled', disabled);
    if (disabled) {
      $link.attr({ 'aria-disabled': 'true', tabindex: '-1' });
    } else {
      $link.removeAttr('aria-disabled').removeAttr('tabindex');
    }
  }

  function getColumnCount() {
    const columnClass = ($nav.attr('class') || '').match(/\bcolumn-count-(\d+)\b/);
    if (!columnClass) {
      return 1;
    }

    const gridTemplateColumns = window.getComputedStyle($nav[0]).gridTemplateColumns;
    const activeColumns = gridTemplateColumns === 'none' ? 1 : gridTemplateColumns.split(' ').length;

    return Math.min(Number.parseInt(columnClass[1], 10), activeColumns);
  }

  function orderItemsByColumn($visibleItems) {
    const columnCount = getColumnCount();

    $items.css('order', '');

    if (columnCount <= 1) {
      return;
    }

    const rowCount = Math.ceil($visibleItems.length / columnCount);

    $visibleItems.each((index, item) => {
      const column = Math.floor(index / rowCount);
      const row = index % rowCount;

      $(item).css('order', (row * columnCount) + column);
    });
  }

  function render() {
    const start = (pageIndex * pageSize) + 1;
    const end = Math.min(total, start + pageSize - 1);
    const $visibleItems = $items.slice(start - 1, end);

    $items.hide();
    $visibleItems.show();
    orderItemsByColumn($visibleItems);

    $range.text(`${start}-${end} of ${total}`);
    setPaginationLinkDisabled($prev, pageIndex === 0);
    setPaginationLinkDisabled($next, end >= total);
  }

  function onPrevClick(event) {
    event.preventDefault();
    if (pageIndex === 0) {
      return;
    }
    pageIndex -= 1;
    render();
  }

  function onNextClick(event) {
    event.preventDefault();
    const lastPageIndex = Math.floor((total - 1) / pageSize);
    if (pageIndex >= lastPageIndex) {
      return;
    }
    pageIndex += 1;
    render();
  }

  $prev.on('click', onPrevClick);
  $next.on('click', onNextClick);
  $.breakpoint('change', render);

  render();
}

Mmg.addShortcode(
  'links.property-count',
  '.sc-links--property-count .pagination',
  initLinksPropertyCountPagination
);

